import { httpClient } from '../../../../net/httpClient';
import UrlConfig from '../../../../net/UrlConfig';

import {
    QUERY_CITIC_RISK_MONITORING_START,
    QUERY_CITIC_RISK_MONITORING_SUCCESS,
    QUERY_CITIC_RISK_MONITORING_FAILURE,
    CITIC_RISK_MONITORING_SEARCH_CHANGE_INPUT,
} from './fundRiskMonitoringConstants';

export function citicRiskMonitoringSearchChangeInput({name, value}) {
    return {
        type: CITIC_RISK_MONITORING_SEARCH_CHANGE_INPUT,
        payload: { name, value, }
    };
}

export function queryCiticRiskMonitoring(params) {
    const requestParams = {
        fundCode: params.fundCode || '',
        date: params.date ? params.date.format("YYYY-MM-DD") : ''
    };
    return function(dispatch) {
        dispatch({ type: QUERY_CITIC_RISK_MONITORING_START });
        httpClient
            .get(UrlConfig.QUERY_CITIC_RISK_MONITORING, requestParams)
            .then(resp => dispatch({ type: QUERY_CITIC_RISK_MONITORING_SUCCESS, payload: resp }))
            .catch(err => dispatch({ type: QUERY_CITIC_RISK_MONITORING_FAILURE, payload: err }));
    };
}
